import React from "react";
import { Range } from "react-range";
import { colors } from "../constants/colors";
import { cleanNumbers } from "../constants/utils";

export default function IntervalFilter({ filter, onItemSelected }) {
  if (!filter.items || filter.items.length < 2) {
    return <p>In order to use the interval filter there must be at least two values to set min and max.</p>;
  }

  if (filter.selectedMin && filter.selectedMax && Number(filter.selectedMin) === Number(filter.selectedMax)) {
    return <p>In order to work, the interval filter min and max value cannot match.</p>;
  }

  let nMin = cleanNumbers(filter.items.at(0).text);
  let nMax = cleanNumbers(filter.items.at(-1).text);
  const STEP = 0.1;

  const [values, setValues] = React.useState([]);

  React.useEffect(() => {
    if (!filter.selectedMin || !filter.selectedMax) {
      setValues([nMin, nMax]);
    } else {
      // Sometimes the ProductCategory-filter passed down to the product page
      // is higher or lower than the items' lowest / highest values present.
      // Therefore we must check this, and switch faulty value(s) for
      // nMax or nMin.
      // This also applies to when sibling filters remove or change min / max values.
      var maxToSet = Number(filter.selectedMax) > nMax ? nMax : Number(filter.selectedMax);
      var minToSet = Number(filter.selectedMin) < nMin ? nMin : Number(filter.selectedMin);

      if (Number(filter.selectedMax) > nMax) {
        console.log("passed max:", filter.selectedMax, " is bigger than items max: ", nMax + ". Using " + nMax);
      }

      if (Number(filter.selectedMin) < nMin) {
        console.log("passed min:", filter.selectedMin, " is smaller than items min: ", nMin + ". Using " + nMin);
      }

      setValues([minToSet, maxToSet]);
    }
  }, [filter.items]);

  const handleRangeSelect = (values) => {
    filter.selectedMin = values.at(0);
    filter.selectedMax = values.at(-1);
  };

  const handleIntervalTrigger = () => {
    // We have to do a fake range select here
    // in case we have initial values or stored values.
    // If we dont, onItemSelected will trigger
    // without filter.selectedMin/Max being set,
    // thus not applying the filter.

    handleRangeSelect(values);
    onItemSelected(values);
  };

  if (values.length !== 2) {
    return null;
  }

  return (
      <div className="ps-3">
      <div style={{ ...styles.container }}>
        <Range
          allowOverlap={false}
          draggableTrack
          values={values}
          step={STEP}
          min={nMin}
          max={nMax}
          onChange={(values) => setValues(values)}
          onFinalChange={(values) => setValues(values)}
          renderTrack={({ props, children }) => (
            <div {...props} style={{ ...props.style, ...styles.track }}>
              {children}
            </div>
          )}
          renderThumb={({ index, props, isDragged }) => (
            <div
              {...props}
              style={{
                ...props.style,
                ...styles.thumb,
              }}
            >
              <div style={{ ...styles.tooltip }}>{values[index]}</div>
            </div>
          )}
        />

        <button className="c-button__solid c-button__tiny" onClick={handleIntervalTrigger}>
          {i18n.getString("productFilter.apply")}
        </button>
      </div>
    </div>
  );
}

const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    flex: 1,
    maxWidth: 500,
    marginVertical: 20,
    columnGap: 20,
    alignItems: "center",
  },
  thumb: {
    height: "24px",
    width: "15px",
    borderRadius: "2px",
    backgroundColor: colors.white,
    border: "2px solid " + colors.cejnBlue,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  tooltip: {
    position: "absolute",
    bottom: "-34px",
    color: colors.white,
    fontWeight: "bold",
    fontSize: "14px",
    fontFamily: "Arial,Helvetica Neue,Helvetica,sans-serif",
    padding: "2px 4px",
    borderRadius: "3px",
    backgroundColor: colors.cejnBlue,
  },
  track: {
    height: "2px",
    width: "100%",
    backgroundColor: colors.gray.dark,
    flex: 1,
  },
};
